// src/core/i18n/en.js
/**
 * English translations
 */
const enTranslations = {
  // Common
  common: {
    welcome: "Welcome to MGX AI Digital Emotional Companion Platform",
    loading: "Loading...",
    error: "An error occurred",
    retry: "Retry",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search",
    more: "More",
    back: "Back",
    submit: "Submit",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    yes: "Yes",
    no: "No",
    success: "Success",
    failed: "Failed",
    notFound: "Not Found",
    unknown: "Unknown",
    all: "All"
  },
  
  // Navigation
  nav: {
    home: "Home",
    aiCompanion: "AI Companion",
    virtualPet: "Virtual Pet",
    digitalHuman: "Digital Immortality",
    vrExperience: "VR Experience",
    store: "Store",
    feedback: "User Feedback",
    investment: "Investment & Jobs",
    profile: "Profile",
    settings: "Settings"
  },
  
  // Authentication
  auth: {
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    name: "Name",
    phone: "Phone",
    verificationCode: "Verification Code",
    sendVerificationCode: "Send Code",
    loginWithEmail: "Email Login",
    loginWithPhone: "Phone Login",
    registerWithEmail: "Email Registration",
    registerWithPhone: "Phone Registration",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    loginSuccess: "Login Successful",
    registerSuccess: "Registration Successful",
    logoutSuccess: "Logout Successful",
    passwordResetSuccess: "Password Reset Successful",
    passwordsDontMatch: "Passwords don't match",
    invalidEmail: "Invalid email format",
    invalidPhone: "Invalid phone number format",
    weakPassword: "Password is too weak, use at least 8 characters with letters and numbers",
    membershipStatus: "Membership Status",
    standardMember: "Standard Member",
    premiumMember: "Premium Member",
    upgradeMembership: "Upgrade Membership"
  },
  
  // AI Companion
  aiCompanion: {
    title: "AI Emotional Companion",
    description: "Have warm conversations with AI characters and build emotional connections",
    characters: "Characters",
    createCharacter: "Create Character",
    characterName: "Character Name",
    personality: "Personality",
    backstory: "Backstory",
    voiceType: "Voice Type",
    chatHistory: "Chat History",
    clearChat: "Clear Chat",
    sendMessage: "Send Message",
    voiceChat: "Voice Chat",
    roleplay: "Role Play",
    emotionalSupport: "Emotional Support",
    virtualDating: "Virtual Dating",
    companionship: "Companionship",
    messageInput: "Type a message...",
    emotionAnalysis: "Emotion Analysis",
    memories: "Memories",
    relationship: "Relationship Level",
    customizeAppearance: "Customize Appearance",
    publicCharacters: "Public Characters",
    myCharacters: "My Characters",
    avatarSelection: "Select Avatar"
  },
  
  // Virtual Pet
  virtualPet: {
    title: "Virtual Pet",
    description: "Raise and nurture your own virtual pet",
    myPets: "My Pets",
    createPet: "Create Pet",
    petName: "Pet Name",
    species: "Species",
    feed: "Feed",
    play: "Play",
    train: "Train",
    sleep: "Sleep",
    clean: "Clean",
    health: "Health",
    happiness: "Happiness",
    energy: "Energy",
    intelligence: "Intelligence",
    level: "Level",
    experience: "Experience",
    skills: "Skills",
    inventory: "Inventory",
    shop: "Pet Shop",
    foodItems: "Food Items",
    toys: "Toys",
    accessories: "Accessories",
    interactionHistory: "Interaction History"
  },
  
  // Digital Human
  digitalHuman: {
    title: "Digital Immortality",
    description: "Create and preserve digitized personalities and memories",
    myDigitalHumans: "My Digital Humans",
    createDigitalHuman: "Create Digital Human",
    name: "Name",
    uploadMedia: "Upload Media",
    trainMemory: "Train Memory",
    familyTree: "Family Tree",
    relationships: "Relationships",
    memories: "Memories",
    importantEvents: "Important Events",
    timeline: "Timeline",
    personalityTraits: "Personality Traits",
    conversationStyle: "Conversation Style",
    voiceModel: "Voice Model",
    recordVoice: "Record Voice",
    memoriesDatabase: "Memories Database",
    exportData: "Export Data",
    importData: "Import Data",
    privacySettings: "Privacy Settings",
    trainingStatus: "Training Status",
    chatWithDigitalHuman: "Chat with Digital Human"
  },
  
  // VR Experience
  vrExperience: {
    title: "VR Experience",
    description: "Immersive virtual reality interactions",
    enterVR: "Enter VR Mode",
    exitVR: "Exit VR Mode",
    environments: "Environments",
    characters: "Characters",
    interactions: "Interactions",
    vrDevices: "Supported Devices",
    vrTutorial: "VR Tutorial",
    compatibility: "Compatibility Check",
    performanceSettings: "Performance Settings",
    navigation: "Navigation Controls",
    immersiveModes: "Immersive Modes",
    virtualRoom: "Virtual Room",
    outdoorScenes: "Outdoor Scenes",
    fantasyWorlds: "Fantasy Worlds",
    historyScenes: "Historical Scenes",
    deviceRequired: "VR Device Required",
    webVRExperience: "Web VR Experience",
    fullVRExperience: "Full VR Experience"
  },
  
  // Store
  store: {
    title: "Store",
    description: "Purchase various digital goods and services",
    products: "Products",
    cart: "Cart",
    orders: "Orders",
    checkout: "Checkout",
    payment: "Payment",
    totalAmount: "Total Amount",
    addToCart: "Add to Cart",
    removeFromCart: "Remove from Cart",
    continueShopping: "Continue Shopping",
    emptyCart: "Your cart is empty",
    orderHistory: "Order History",
    orderDate: "Order Date",
    orderStatus: "Order Status",
    productDetails: "Product Details",
    relatedProducts: "Related Products",
    categories: {
      all: "All Categories",
      avatar: "Avatars",
      accessory: "Accessories",
      background: "Backgrounds",
      voice: "Voices",
      feature: "Features"
    },
    filter: "Filter",
    sort: "Sort",
    priceRange: "Price Range"
  },
  
  // User Feedback
  feedback: {
    title: "User Feedback",
    description: "Share your experience and suggestions",
    submitFeedback: "Submit Feedback",
    feedbackType: "Feedback Type",
    subject: "Subject",
    message: "Message",
    rating: "Rating",
    bug: "Bug Report",
    suggestion: "Feature Suggestion",
    complaint: "Complaint",
    praise: "Praise",
    other: "Other",
    attachScreenshot: "Attach Screenshot",
    yourFeedback: "Your Feedback",
    feedbackHistory: "Feedback History",
    responseFromTeam: "Response from Team",
    feedbackSubmitted: "Feedback Submitted",
    thanksForFeedback: "Thank you for your feedback",
    waitingForResponse: "Waiting for response"
  },
  
  // Investment & Recruitment
  investment: {
    title: "Investment & Jobs",
    description: "Investment opportunities and join our team",
    investmentOpportunities: "Investment Opportunities",
    careers: "Careers",
    aboutUs: "About Us",
    companyVision: "Company Vision",
    contactUs: "Contact Us",
    investorRelations: "Investor Relations",
    jobOpenings: "Job Openings",
    applyNow: "Apply Now",
    requiredSkills: "Required Skills",
    responsibilities: "Responsibilities",
    qualifications: "Qualifications",
    location: "Location",
    remote: "Remote",
    salary: "Salary",
    sendResume: "Send Resume",
    meetTeam: "Meet the Team",
    fundingRounds: "Funding Rounds",
    partnerships: "Partnerships"
  },
  
  // Settings
  settings: {
    title: "Settings",
    account: "Account Settings",
    profile: "Profile",
    security: "Security",
    privacy: "Privacy",
    notifications: "Notifications",
    language: "Language",
    theme: "Theme",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    autoTheme: "Auto Theme",
    dataUsage: "Data Usage",
    syncSettings: "Sync Settings",
    deleteAccount: "Delete Account",
    updateProfile: "Update Profile",
    changePassword: "Change Password",
    linkedAccounts: "Linked Accounts",
    twoFactorAuth: "Two-Factor Authentication",
    dataSharingOptions: "Data Sharing Options",
    pushNotifications: "Push Notifications",
    emailNotifications: "Email Notifications",
    paymentMethods: "Payment Methods",
    billingHistory: "Billing History",
    autoRenewal: "Auto-Renewal"
  },
  
  // Error messages
  errors: {
    general: "Something went wrong, please try again later",
    network: "Network connection failed",
    unauthorized: "Unauthorized, please log in",
    forbidden: "Access forbidden",
    notFound: "Requested resource not found",
    serverError: "Server error",
    validation: "Validation failed",
    timeout: "Request timed out",
    loginRequired: "Login required",
    expiredSession: "Your session has expired, please log in again",
    rateLimited: "Too many requests, please try again later"
  },
};

export default enTranslations;